export const removeHostFromUrl = (url: string): string => {
  try {
    const { hash, pathname, search } = new URL(url);
    return `${pathname}${search}${hash}`;
  } catch (_e) {
    return url || "";
  }
};
